import { LottoChangeDataInterface } from '../types/interface'

// CHANCE+ 3
export const LottoChange3Data: LottoChangeDataInterface[] = [
    { number: '3', bonus: '0', premiers: '5,000,000', gains: '82,000,000', derniers: '3,200,000' },
    { number: '2', bonus: '1', premiers: '96,000', gains: '160,000', derniers: '64,000' },
    { number: '1', bonus: '2', premiers: '96,000', gains: '160,000', derniers: '64,000' },
    { number: '2', bonus: '0', premiers: '50,000', gains: '80,000', derniers: '30,000' },
    { number: '1', bonus: '1', premiers: '2,000', gains: '4,000', derniers: '2,000' },
    { number: '0', bonus: '2', premiers: '2,000', gains: '4,000', derniers: '2,000' },
]

// CHANCE+ 4
export const LottoChange4Data: LottoChangeDataInterface[] = [
    { number: '4', bonus: '0', premiers: '24,000,000', gains: '40,000,000', derniers: '16,000,000' },
    { number: '3', bonus: '1', premiers: '2,400,000', gains: '4,000,000', derniers: '1,600,000' },
    { number: '2', bonus: '2', premiers: '2,400,000', gains: '4,000,000', derniers: '1,600,000' },
    { number: '3', bonus: '0', premiers: '500,000', gains: '700,000', derniers: '200,000' },
    { number: '2', bonus: '1', premiers: '42,000', gains: '70,000', derniers: '28,000' },
    { number: '1', bonus: '2', premiers: '42,000', gains: '70,000', derniers: '28,000' },
    { number: '2', bonus: '0', premiers: '40,000', gains: '60,000', derniers: '20,000' },
    { number: '1', bonus: '1', premiers: '4,000', gains: '6,000', derniers: '2,000' },
    { number: '0', bonus: '2', premiers: '4,000', gains: '6,000', derniers: '2,000' },
]

// CHANCE+ 5
export const LottoChange5Data: LottoChangeDataInterface[] = [
    { number: '5', bonus: '0', premiers: '240,000,000', gains: '400,000,000', derniers: '160,000,000' },
    { number: '4', bonus: '1', premiers: '24,000,000', gains: '40,000,000', derniers: '16,000,000' },
    { number: '3', bonus: '2', premiers: '24,000,000', gains: '40,000,000', derniers: '16,000,000' },
    { number: '4', bonus: '0', premiers: '6,000,000', gains: '10,000,000', derniers: '4,000,000' },
    { number: '3', bonus: '1', premiers: '600,000', gains: '1,000,000', derniers: '400,000' },
    { number: '2', bonus: '2', premiers: '600,000', gains: '1,000,000', derniers: '400,000' },
    { number: '3', bonus: '0', premiers: '240,000', gains: '400,000', derniers: '160,000' },
    { number: '2', bonus: '1', premiers: '24,000', gains: '40,000', derniers: '16,000' },
    { number: '1', bonus: '2', premiers: '24,000', gains: '40,000', derniers: '16,000' },
    { number: '2', bonus: '0', premiers: '18,000', gains: '30,000', derniers: '12,000' },
]

// CHANCE+
export const lottoChanceData = [
    {
        game: 'CHANCE+ 3',
        data: [...LottoChange3Data],
    },
    {
        game: 'CHANCE+ 4',
        data: [...LottoChange4Data],
    },
    {
        game: 'CHANCE+ 5',
        data: [...LottoChange5Data],
    },
]
